module.exports = __webpack_public_path__ + "static/img/icon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.png
// module id = fqxG
// module chunks = 3